'use client';

import { useEffect, useRef, useState } from 'react';
import { observeHeroMotion } from '../lib/hero-motion';
import styles from './ConversationPortrait.module.scss';

const descriptions = {
 'chat-customer': {tr:'Telefonundan siparişini kontrol eden müşteri',en:'A customer checking an order on her phone'},
 'automation-customer': {tr:'Teslim aldığı ürün için telefonundan yardım isteyen müşteri',en:'A customer using his phone to get help with a delivery'},
 'support-agent': {tr:'Bilgisayarından müşteriye yardımcı olan destek temsilcisi',en:'A support agent helping a customer from her laptop'},
 'hotel-guest': {tr:'Telefonundan otelle iletişime geçen misafir',en:'A guest contacting the hotel on his phone'},
 'travel-customer': {tr:'Telefonundan seyahatini planlayan müşteri',en:'A customer planning a trip on her phone'},
 'voice-caller': {tr:'Telefon görüşmesi yapan müşteri',en:'A customer making a phone call'},
};

export default function ConversationPortrait({scene,locale='en',priority=false,children}) {
 const bubbles = useRef(null);
 const [motion, setMotion] = useState({reduced:true,active:false});
 useEffect(() => observeHeroMotion(bubbles.current, setMotion), []);
 const base='/brand/conversations/'+scene+'-v1';
 return <div className={styles.stage}>
  <div className={styles.frame}><img src={base+'.webp'} srcSet={base+'-640.webp 640w, '+base+'.webp 1024w'} sizes="(max-width: 800px) calc(100vw - 64px), 560px" width={1024} height={1024} alt={descriptions[scene][locale==='tr'?'tr':'en']} loading={priority?'eager':'lazy'} fetchPriority={priority?'high':undefined} decoding="async"/></div>
  <div ref={bubbles} className={styles.bubbles} data-hero-dialogue="" data-motion={!motion.reduced} data-playing={motion.active && !motion.reduced}>{children}</div>
 </div>;
}

